module.exports = __webpack_public_path__ + "static/img/people4.e9377ff9.png";